import { render, staticRenderFns } from "./ClinicsAndServicesTab.vue?vue&type=template&id=c3f5dd06&scoped=true"
import script from "./ClinicsAndServicesTab.vue?vue&type=script&lang=js"
export * from "./ClinicsAndServicesTab.vue?vue&type=script&lang=js"
import style0 from "./ClinicsAndServicesTab.vue?vue&type=style&index=0&id=c3f5dd06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f5dd06",
  null
  
)

export default component.exports